'use client';

import { FC } from 'react';
import { Button, ButtonProps } from '@chakra-ui/react';
import colors from '@/constants/theme/colors';

interface ClearFiltersProps extends ButtonProps {
  onClear?: () => void;
  isDisabled?: boolean;
}
const ClearFilters: FC<ClearFiltersProps> = ({ onClear, isDisabled }) => {
  const handleClick = () => {
    if (isDisabled) return;
    onClear?.();
  };

  return (
    <Button variant="tertiarySm" onClick={handleClick}>
      Clear all
    </Button>
  );
};

export default ClearFilters;
